import "./style.css";
import { AiFillGithub, AiOutlineMail } from "react-icons/ai";
import { BsLinkedin } from "react-icons/bs";
import { SiVsco } from "react-icons/si";
import { FaMedium } from "react-icons/fa";
import { SlArrowDown } from "react-icons/sl";
import { Link } from "react-scroll";
import { FaXTwitter } from "react-icons/fa6";
import { IoBookOutline } from "react-icons/io5";
import { useLanguage } from "../../context/LanguageContext";

const Intro = () => {
  const { t } = useLanguage();

  return (
    <section id="intro">
      <div className="intro-overlay"></div>

      <div className="intro-content">
        <div className="row">
          <div className="col-twelve">
            <h5>{t("intro.greeting")}</h5>
            <h1>{t("intro.name")}</h1>

            <p className="intro-position">
              <span>{t("intro.role")}</span>
            </p>

            <Link
              className="button stroke"
              to="about"
              spy={true}
              smooth={true}
              duration={700}
              offset={-90}
            >
              {t("intro.cta")}{" "}
              <SlArrowDown
                style={{
                  paddingTop: 1,
                  marginLeft: 5,
                }}
              />
            </Link>
          </div>
        </div>
      </div>

      <ul className="intro-social">
        <li>
          <a
            href="https://www.linkedin.com/in/berkanankal/"
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin />
          </a>
        </li>
        <li>
          <a
            href="https://github.com/berkanankal"
            target="_blank"
            rel="noreferrer"
          >
            <AiFillGithub />
          </a>
        </li>

        <li>
          <a
            href="https://medium.com/@berkan.ankal"
            target="_blank"
            rel="noreferrer"
          >
            <FaMedium />
          </a>
        </li>
        <li>
          <a href="mailto:berkan.ankal@outlook.com">
            <AiOutlineMail />
          </a>
        </li>
        <li>
          <a
            href="https://vsco.co/berkanankal"
            target="_blank"
            rel="noreferrer"
          >
            <SiVsco />
          </a>
        </li>
        <li>
          <a
            href="https://x.com/berkanankal"
            target="_blank"
            rel="noreferrer"
          >
            <FaXTwitter />
          </a>
        </li>
        <li>
          <a
            href="https://1000kitap.com/berkanankal"
            target="_blank"
            rel="noreferrer"
          >
            <IoBookOutline />
          </a>
        </li>
      </ul>
    </section>
  );
};

export default Intro;
